"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScrollingDown = void 0;
var previousScrollPosition = 0;
var isScrollingDown = function () {
    var scrollPosition = window.scrollY;
    var scrollingDown = scrollPosition > previousScrollPosition;
    previousScrollPosition = scrollPosition;
    return scrollingDown;
};
exports.isScrollingDown = isScrollingDown;
